/* eslint-disable import/prefer-default-export */
export const module = '/programs'
